import { Injectable } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import type { Option } from '@comparit/core';
import { map, startWith } from 'rxjs';
import type {
  Bauweise,
  Dacheindeckung,
  Fertighaus,
  Step3FormInput,
  Step4FormInput,
  Step5FormInput,
  Step6FormInput,
} from '../../interfaces';
import { BaseForm } from '../base-form';
import { Step3Form } from './modules/step3-form';
import { Step4Form } from './modules/step4-form';
import { Step5Form } from './modules/step5-form';
import { Step6Form } from './modules/step6-form';
import { bauweiseOptions } from './options/bauweise-options';
import { dacheindeckungOptions } from './options/dacheindeckung-options';
import { fertighausOptions } from './options/fertighaus-options';
import { gebaeudetypOptions } from './options/gebaeudetyp-options';

export interface GebaeudedatenStepForms {
  step3: Step3FormInput;
  step4: Step4FormInput;
  step5: Step5FormInput;
  step6: Step6FormInput;
}

@Injectable({ providedIn: 'root' })
export class GebaeudedatenFormService {
  readonly gebaeudetypOptions = gebaeudetypOptions;
  readonly dacheindeckungOptions: Option<Dacheindeckung>[] = dacheindeckungOptions;
  readonly bauweiseAussenwaendeOptions: Option<Bauweise>[] = bauweiseOptions;
  readonly fertighausOptions: Option<Fertighaus>[] = fertighausOptions;
}

export class GebaeudedatenFormCreator extends BaseForm {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: GebaeudedatenStepForms | null
  ) {
    super();
  }

  public step3Form = new Step3Form(this.fb, this.defaultValue?.step3);
  public step4Form = new Step4Form(this.fb, this.defaultValue?.step4);
  public step5Form = new Step5Form(this.fb, this.defaultValue?.step5);
  public step6Form = new Step6Form(this.fb, this.defaultValue?.step6);

  override stepsCtrls = {
    step3: this.step3Form.fg,
    step4: this.step4Form.fg,
    step5: this.step5Form.fg,
    step6: this.step6Form.fg,
  };

  _fg = this.fb.group(this.stepsCtrls);
  fgDefaultValue = this._fg.getRawValue();

  fgValueChanges$ = this._fg.valueChanges.pipe(
    map(() => this._fg.getRawValue() as GebaeudedatenStepForms)
  );

  fgValue$ = this._fg.valueChanges.pipe(
    startWith(null),
    map(() => this._fg.getRawValue() as GebaeudedatenStepForms)
  );
}
